import { useEffect } from "react";

const SITE_NAME = "HouseDesignWala™";
const DEFAULT_TITLE = `${SITE_NAME} — Online House Design & Construction Drawings (India)`;

function setMetaTag(attr, key, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

// Every route previously shared the exact same static <title>/meta
// description from public/index.html — real, differentiated per-page
// titles are one of the most basic on-page SEO signals, and Google/social
// previews both read whatever is live in the DOM at crawl/share time, so
// plain DOM mutation here is enough (no react-helmet dependency needed for
// a CSR-only site like this one — there's no SSR to hydrate a head tag
// into). Call once near the top of a page component; unmounting restores
// the site-wide default so navigating to an un-migrated route (or back to
// one) never leaves a stale title behind.
export default function useDocumentTitle(pageTitle, description) {
  useEffect(() => {
    const fullTitle = pageTitle ? `${pageTitle} | ${SITE_NAME}` : DEFAULT_TITLE;
    document.title = fullTitle;
    setMetaTag("property", "og:title", fullTitle);
    setMetaTag("name", "twitter:title", fullTitle);
    if (description) {
      setMetaTag("name", "description", description);
      setMetaTag("property", "og:description", description);
      setMetaTag("name", "twitter:description", description);
    }
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [pageTitle, description]);
}
